import { JobState } from "../dto/job-state.enum";

    /**
     * @description
     *  Modelo del estado de un job asincrónico.
     *
     * @see gigot-backend/Core/DataTransferObject/AsyncJobState.cs
     */

export class AsyncJobState {

    public jobState: JobState;
	public estimatedCompletionTimestamp: Date;

    /**
     * @description
     *	Construye un estado de job asincrónico con una semántica vacía. Nótese
	 *	que no es lo mismo que construir un descuento con valores por defecto.
	 *	Las reglas generales de construcción son:
     *
     *      - Campos 'array' se definen como [].
     *      - Campos 'boolean' se definen como 'false'.
     *      - Campos 'Date' se definen como 'undefined'.
     *      - Campos 'enum' se definen como 'undefined'.
     *      - Campos 'number' se definen como 'undefined'.
     *      - Campos 'string' se definen como '' (cadena vacía).
     *      - Campos 'object' se definen llamando a su propio método #empty().
     *      - Campos de la superclase se definen al igual que campos 'object'.
     *      - Campos genéricos se definen como 'undefined'.
	 *		- Campos recursivos se definen como 'undefined'.
     *
     * @returns
     *	Un estado de job asincrónico vacío.
     */
    public static empty(): AsyncJobState {
        const asyncJobState: AsyncJobState = new AsyncJobState();
		asyncJobState.estimatedCompletionTimestamp = undefined;
		asyncJobState.jobState = undefined;
		return asyncJobState;
    }

	/**
     * @description
     *  Método de reificación de un modelo compatible anémico. Esto permite
     *  ejecutar lógica de negocios sobre el modelo generado, siendo que el
     *  valor de sus propiedades se mantiene.
     *
     * @param anemicAsyncJobState
     *  El modelo anémico a reificar.
     *
     * @returns
     *  Devuelve un modelo de esta clase, cuyas propiedades fueron copiadas en
     *  profundidad desde el modelo anémico.
     */
	public static from(anemicAsyncJobState: AsyncJobState): AsyncJobState {
		if (!anemicAsyncJobState) return undefined;
        const asyncJobState: AsyncJobState = AsyncJobState.empty();
		asyncJobState.estimatedCompletionTimestamp = anemicAsyncJobState.estimatedCompletionTimestamp;
		asyncJobState.jobState = anemicAsyncJobState.jobState;
		return asyncJobState;
	}
}
